import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import Portuguese translations
import ptCommon from './locales/pt/common.json';
import ptLanding from './locales/pt/landing.json';
import ptAuth from './locales/pt/auth.json';
import ptDashboard from './locales/pt/dashboard.json';
import ptDocuments from './locales/pt/documents.json';
import ptProfile from './locales/pt/profile.json';
import ptNotifications from './locales/pt/notifications.json';

// Import English translations
import enCommon from './locales/en/common.json';
import enLanding from './locales/en/landing.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enDocuments from './locales/en/documents.json';
import enProfile from './locales/en/profile.json';
import enNotifications from './locales/en/notifications.json';

const resources = {
  pt: {
    common: ptCommon,
    landing: ptLanding,
    auth: ptAuth,
    dashboard: ptDashboard,
    documents: ptDocuments,
    profile: ptProfile,
    notifications: ptNotifications,
  },
  en: {
    common: enCommon,
    landing: enLanding,
    auth: enAuth,
    dashboard: enDashboard,
    documents: enDocuments,
    profile: enProfile,
    notifications: enNotifications,
  },
};

// Custom language detector that checks URL path for /en prefix
const pathLanguageDetector = {
  name: 'pathDetector',
  lookup() {
    const path = window.location.pathname;
    if (path.startsWith('/en/') || path === '/en') {
      return 'en';
    }
    return 'pt';
  },
  cacheUserLanguage(lng: string) {
    localStorage.setItem('i18nextLng', lng);
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(pathLanguageDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt',
    supportedLngs: ['pt', 'en'],
    defaultNS: 'common',
    ns: ['common', 'landing', 'auth', 'dashboard', 'documents', 'profile', 'notifications'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['pathDetector', 'localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;

// Helper function to get language-prefixed path
export const getLocalizedPath = (path: string, lang: string): string => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  if (lang === 'en') {
    return `/en${cleanPath}`;
  }
  return cleanPath;
};

// Helper function to remove language prefix from path
export const removeLanguagePrefix = (path: string): string => {
  if (path.startsWith('/en/')) {
    return path.substring(3);
  }
  if (path === '/en') {
    return '/';
  }
  return path;
};

// Helper function to get current language from path
export const getLanguageFromPath = (): string => {
  const path = window.location.pathname;
  if (path.startsWith('/en/') || path === '/en') {
    return 'en';
  }
  return 'pt';
};
